"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Thumbnail_Button_1 = __importDefault(require("./Thumbnail.Button"));
var Text_1 = __importDefault(require("../Text"));
require("./Thumbnail.css");
function Plus(_a) {
    var src = _a.src, altText = _a.altText, aspectRatio = _a.aspectRatio, width = _a.width, ariaLabel = _a.ariaLabel, number = _a.number, onClick = _a.onClick;
    return (React.createElement(Thumbnail_Button_1.default, { aspectRatio: aspectRatio, width: width, ariaLabel: ariaLabel, onClick: onClick, className: "nimbus--thumbnail-plus" },
        React.createElement("div", { className: "nimbus--thumbnail-overlay nimbus--thumbnail-overlay--blue" },
            React.createElement(Text_1.default, { size: "featured" },
                "+",
                number)),
        React.createElement("img", { src: src, alt: altText, className: "nimbus--thumbnail" })));
}
exports.default = Plus;
//# sourceMappingURL=Thumbnail.Plus.js.map